export const defaultDialogPaddingXClass = 'px-3';
export const defaultDialogPaddingYClass = 'py-2a';
